export function validateAmount(amount) {
  console.log("Validate amount: ", amount)
  let stringAmount = `${amount}`

  if (stringAmount.includes('.')) {
    var count = stringAmount.split('.').length - 1 
    if (count > 1) {
      console.error("Multiple decimal places in the amount")
      return true
    }
  } 

  if (stringAmount.includes(',')) {
    count = stringAmount.split(',').length - 1 
    if (count > 1) {
      console.error("Multiple commas  in the amount")
      return true
    }
  }

  if (stringAmount.includes('.')) {
    let cents = stringAmount.split('.')[1]
    if (cents.length > 2) {
      console.error("More than 2 decimal places in amount")
      return true
    }
    let dollars = stringAmount.split('.')[0]
    if (dollars.length > 6) {
      console.error("Amount too large")
      return true
    }
  } else {
    if (stringAmount.length > 6) {
      console.error("Amount too large")
      return true
    }
  }
  return false
}